export default {
  title: 'Data e Hora',
  buttons: {
    done: 'Concluído',
  },
};
